<template>
  <div class="add-webpage flex-grow-1 d-flex flex-column overflow-y-hidden">
    <a-form id="add-webpage-form" class="flex-grow-1 d-flex flex-column overflow-y-hidden" :form="addWebpageForm" @submit="onSubmit">
      <div class="a-header">
        <span class="a-header--title slide-down-enter-active">Add Webpages</span>
      </div>
      <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
        <Spinner />
      </div>
      <div class="a-body flex-grow-1">
        <transition-group name="slide-up">
          <template v-if="!isLoading && domains && domains.length == 0">
            <a-row :key="'info'" :gutter="20">
              <a-col :span="24">
                <p>You have not added any domains. You need to have one or more domains before you can add webpages to a domain.</p>
              </a-col>
            </a-row>
          </template>
          <template v-if="!isLoading && domains && domains.length > 0">
            <a-row :key="'info1'" :gutter="24">
              <a-col :span="24" v-if="isLimitUrl">
                <a-alert type="error" message="URL Limit has reached. Please upgrade or contact us." banner />
              </a-col>
              <!-- <a-col :span="24">
                <a-form-item>
                  <a-radio-group v-model="mode" :disabled="isLimitUrl">
                    <a-radio :value="1">Single</a-radio>
                    <a-radio :value="2">Multiple</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col> -->
            </a-row>
            <a-row :key="'info2'" :gutter="24">
              <a-col :span="24">
                <div v-if="isSuccessMultipleBaseline">
                  <a-alert
                          message="Webpages Queued"
                          type="success"
                          show-icon
                          closable
                  >
                    <template slot="description">
                      <p class="mb-1 notice-text">{{ multipleReBaselineData.total }} webpages has been queued for baseline.</p>
                      <p class="mb-1 notice-text">
                        This may take a few minutes to a few hours depending on the number of pages.
                      </p>
                      <p class="mb-1 notice-text">
                        You may check the status of this batch job
                        <span>
                          <router-link
                                  class="nav-link-detail"
                                  :to="{
                              path: '/batch-jobs/detail/BL' + multipleReBaselineData.batchId
                            }"
                          >
                            ID BL{{ multipleReBaselineData.batchId }} at this link.
                          </router-link>
                        </span>
                      </p>
                      <p class="mb-0 notice-text">An email will be sent to {{ currentUserName }} when the job is finished.</p>
                    </template>
                  </a-alert>
                </div>
              </a-col>
            </a-row>
            <a-row :key="'info3'" :gutter="24">
              <a-col :span="12">
                <a-form-item label="Select Domain">
                  <a-select
                          v-decorator="[
                      'domainId',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please select a domain'
                          }
                        ]
                      }
                    ]"
                          size="large"
                  >
                    <a-select-option v-for="domain in domains" :key="domain.id">
                      {{ domain.domain_name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">

              </a-col>
            </a-row>
            <a-row :key="'info4'" :gutter="24">
              <a-col :span="24">
                <a-form-item :extra="mode === 2 ? 'Enter (or paste) your list of webpages (maximum 200 URLs)' : ''">
                  <template slot="label">
                    Webpage URLs
                    <a-tooltip placement="top">
                      <template slot="title">
                        <span class="fs-10">
                          The URLs of the webpages to be monitored.
                        </span>
                      </template>
                      <a-icon type="info-circle" theme="filled" />
                    </a-tooltip>
                  </template>
                  <a-input
                    v-decorator="[
                      'webpageUrl',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please input URL!'
                          },
                          {
                            pattern: REGEX_URL_WITH_PROTOCOL,
                            message: 'Please input valid URL! (eg. https://www.example.com)'
                          }
                        ]
                      }
                    ]"
                    placeholder="URL"
                    type="text"
                    v-if="mode === 1"
                    :disabled="isLimitUrl"
                  />
                  <a-textarea
                    v-decorator="[
                      'webpageUrls',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please input URLs!'
                          }
                        ]
                      }
                    ]"
                    :autoSize="{ minRows: 5, maxRows: 7 }"
                    placeholder="eg. http://www.banffcyber.com/index.html (for regular HTTP)
    https://www.banffcyber.com/index.html (for secure HTTP)
    http://www.banffcyber.com:8080/demo/demo.html (for pages running on a non-default port, e.g. 8080)"
                    v-if="mode === 2"
                    :disabled="isLimitUrl"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :key="'info5'" :gutter="24">
              <a-col :span="12">
                <a-form-item label="Monitoring Type">
                  <a-radio-group v-decorator="['monitoringType', {rules: [{required: true}]}]">
                    <a-radio value="Committed">Committed</a-radio>
                    <a-radio value="Variable">Variable</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item>
                  <template slot="label">
                    User Agent
                    <a-tooltip placement="top">
                      <template slot="title">
                        <span class="fs-10"> Selects the user agent to be used.<br />We provide both desktop and mobile user agents </span>
                      </template>
                      <a-icon type="info-circle" theme="filled" />
                    </a-tooltip>
                  </template>
                  <a-select
                    v-decorator="[
                      'userAgentId',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please select the user agent id'
                          }
                        ]
                      }
                    ]"
                    size="large"
                    :disabled="isLimitUrl"
                  >
                    <a-select-option v-for="userAgent in userAgents" :key="userAgent.id" :value="userAgent.id">
                      {{ userAgent.alias }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :key="'info6'" :gutter="24">
              <a-col :span="24">
                <a-form-item>
                  <a-checkbox :disabled="isLimitUrl" :checked="isOpenAdvOptions" @change="isOpenAdvOptions = !isOpenAdvOptions">
                    Advanced Options
                  </a-checkbox>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :key="'info7'" :gutter="20" v-show="isOpenAdvOptions">
              <a-col :span="12">
                <a-form-item extra="separate different keywords by a comma (,)">
                  <template slot="label">
                    Keyword(s) to include
                    <a-tooltip placement="top" :overlayStyle="{ 'max-width': 'max-content' }">
                      <template slot="title">
                        <span class="fs-10">
                          Specify the whitelisted keyword(s) that we should monitor on your webpage.<br />
                          An alert will be sent if the whitelisted keywords are missing from the page.<br />
                          Examples: company name, webpage title.
                        </span>
                      </template>
                      <a-icon type="info-circle" theme="filled" />
                    </a-tooltip>
                  </template>
                  <a-textarea v-decorator="['keywordsInclude']" class="row-6 mb-0" :rows="6" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item extra="separate different keywords by a comma (,)">
                  <template slot="label">
                    Keyword(s) to exclude
                    <a-tooltip placement="top" :overlayStyle="{ 'max-width': 'max-content' }">
                      <template slot="title">
                        <span class="fs-10">
                          Specify what blacklisted keyword(s) that should not appear on your webpage.<br />
                          An alert will be sent if the blacklisted keywords are detected on the page.<br />
                          Examples: mysql/php error.
                        </span>
                      </template>
                      <a-icon type="info-circle" theme="filled" />
                    </a-tooltip>
                  </template>
                  <a-textarea v-decorator="['keywordsExclude']" class="row-6 mb-0" :rows="6" />
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </transition-group>
      </div>
      <div class="a-footer">
        <a-button key="back" size="large" class="mr-3 slide-down-enter-active" @click="onCancel()">
          Cancel
        </a-button>
        <a-button :disabled="isLimitUrl" key="submit" size="large" type="primary" html-type="submit" class="slide-down-enter-active">
          Save
        </a-button>
      </div>
    </a-form>
    <a-modal v-model="isShowProgress" class="progress-modal" :footer="null" title="" :closable="false" :maskClosable="false">
      <div>
        <a-progress strokeLinecap="square" :percent="percent" status="active" />
        <p class="mb-1 text-center progress-notice"><a-icon type="sync" spin /> {{ progressNotice }}</p>
        <a-alert
          message="We are doing an intelligent baseline of your page now.
          This process will take about 2 - 3 minutes depending on the contents of the webpage."
          type="warning"
          showIcon
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
  import { REGEX_URL_WITH_PROTOCOL } from '@constants/regex';
  import { flatMapErrMessagesValidateForm, debounceTimeExecute } from '@shared/helpers/utils';
  import WebpageService from '../../Webpages/services/webpage.service';
  import { DEFAULT_USER_AGENT_ID } from '../../Webpages/consts/Webpage.consts';
  import DataService from '@shared/services/data.service';
  import DomainService from "../services/Domain.service";

  export default {
    name: 'DomainWebpageAdd',
    data() {
      return {
        REGEX_URL_WITH_PROTOCOL,
        isOpenAdvOptions: false,
        mode: 2,
        userAgents: [],
        isShowProgress: false,
        percent: 0,
        planTypes: {},
        progressNotice: 'Creating first baseline',
        currentUserName: '',
        isSuccessMultipleBaseline: false,
        multipleReBaselineData: {
          total: 0,
          batchId: ''
        },
        isLimitUrl: false,
        domains: [],
        isLoading: true,
      };
    },
    beforeCreate() {
      this.addWebpageForm = this.$form.createForm(this, {
        name: 'add-webpage-form',
        mapPropsToFields: () => {
          return {
            domainId: this.$form.createFormField({
              value: ''
            }),
            webpageUrl: this.$form.createFormField({
              value: ''
            }),
            webpageUrls: this.$form.createFormField({
              value: ''
            }),
            monitoringType: this.$form.createFormField({
              value: 'Committed'
            }),
            userAgentId: this.$form.createFormField({
              value: DEFAULT_USER_AGENT_ID
            }),
            keywordsInclude: this.$form.createFormField({
              value: ''
            }),
            keywordsExclude: this.$form.createFormField({
              value: ''
            })
          };
        }
      });
      this.addWebpageForm.getFieldDecorator('domainId', {});
    },
    mounted() {
      this.getMasterData();
      this.currentUserName = (this.$store.state && this.$store.state.user && this.$store.state.user.data && this.$store.state.user.data.username) || '';
    },
    methods: {
      onSubmit(e) {
        e.preventDefault();
        this.addWebpageForm.validateFields((err, values) => {
          if (!err) {
            switch (this.mode) {
              case 1: {
                this.addSingleWebpage(values);
                break;
              }
              case 2: {
                this.addMultiplesWebpage(values);
                break;
              }
            }
          }
          if (err) {
            debounceTimeExecute(flatMapErrMessagesValidateForm(err), this.$showErrorMessage);
          }
        });
      },
      async addMultiplesWebpage(formValue) {
        const body = {
          domain_id: formValue.domainId,
          urls: (formValue.webpageUrls || '').split('\n').filter(url => url.trim().length > 0),
          user_agent_id: formValue.userAgentId,
          monitoring_type: formValue.monitoringType,
          text_string_appear: formValue.keywordsInclude || '',
          text_string_not_appear: formValue.keywordsExclude || ''
        };
        try {
          const responseCreateMultiple = await WebpageService.createMultiplesForDomain(body);
          this.$showSuccessMessage('Batch job successfully created for multiple webpages');
          this.addWebpageForm.resetFields();
          this.addWebpageForm.setFieldsValue({
            userAgentId: DEFAULT_USER_AGENT_ID,
            domainId: this.domains[0].id,
            monitoringType: 'Committed',
          });
          this.isSuccessMultipleBaseline = true;
          this.multipleReBaselineData = {
            total: responseCreateMultiple && responseCreateMultiple.batch_baseline_urls && responseCreateMultiple.batch_baseline_urls.length,
            batchId: responseCreateMultiple && responseCreateMultiple.id
          };
        } catch (error) {
          this.$showMultiErrorMessage(error.messages);
        }
      },
      async fetchStatusofTheJob(jobId, urlId) {
        try {
          const verifyResponse = await DataService.fetchStatusJob(jobId);
          const { status, result } = verifyResponse;
          if (status === 'Completed') {
            this.isShowProgress = false;
            this.$showSuccessMessage('Added Webpages successful!');
            this.$router.push(`/webpages/baseline-result/${urlId}`);
          } else if (status === 'Error') {
            this.isShowProgress = false;
            this.percent = 0;
            this.progressNotice = 'Creating first baseline';
            try {
              const resultParsed = JSON.parse(result);
              const errMessage = resultParsed && resultParsed.error && resultParsed && resultParsed.error.message ? resultParsed.error.message : 'Failed to baseline web page';
              this.$showErrorMessage(errMessage);
            } catch {
              this.$showErrorMessage('Failed to baseline web page');
            }
          } else {
            this.progressNotice = result ? JSON.parse(result).message : this.progressNotice;
            const percentPerforming = result ? Math.min(JSON.parse(result).start_progress, 100) : 0;
            this.percent = +percentPerforming.toFixed();
            setTimeout(() => {
              this.fetchStatusofTheJob(jobId, urlId);
            }, 3000);
          }
        } catch (error) {
          this.isShowProgress = false;
          this.$showErrorMessage('The baseline of your webpage is error.');
        }
      },
      async getMasterData() {
        const [userAgentsData, userData, domains] = await Promise.all([DataService.getUserAgents(), DataService.getUsers(), DomainService.fetchListOfDomainSubscribed()]);
        this.userAgents = userAgentsData;
        this.planTypes = userData.plan_usage || {};
        this.domains = domains;
        this.isLimitUrl = Object.keys(this.planTypes).every((key) => this.planTypes[key].count === this.planTypes[key].limit);
        const isLimitTrial = userData.plan_usage && userData.plan_usage['TRIAL'] && userData.plan_usage['TRIAL'].count === userData.plan_usage['TRIAL'].limit;
        const isLimitBronze = userData.plan_usage && userData.plan_usage['BRONZE'] && userData.plan_usage['BRONZE'].count === userData.plan_usage['BRONZE'].limit;
        const isLimitSilver = userData.plan_usage && userData.plan_usage['SILVER'] && userData.plan_usage['SILVER'].count === userData.plan_usage['SILVER'].limit;
        const isLimitGold = userData.plan_usage && userData.plan_usage['GOLD'] && userData.plan_usage['GOLD'].count === userData.plan_usage['GOLD'].limit;
        const defaultPlanType = !isLimitTrial ? 'TRIAL' : !isLimitBronze ? 'BRONZE' : !isLimitSilver ? 'SILVER' : !isLimitGold ? 'GOLD' : 'Limit has reached';

        if (this.domains.length > 0) {
          this.addWebpageForm.setFieldsValue({domainId: this.domains[0].id});
        }

        this.isLoading = false;
      },
      onCancel() {
        this.$router.push('/domain/list');
      }
    }
  };
</script>

<style lang="scss" scoped>
  .a-body {
    padding: 20px;
  }

  .success-rebaseline-container {
    padding: 8px 10px;
    border: 1px solid #7ecf42;
    border-radius: 4px;
    background-color: #f3ffea;
    display: flex;
    align-items: center;
    .notice-text {
      font-size: 1rem;
    }
    .check-success {
      font-size: 40px;
      color: rgb(126, 207, 66);
    }
  }
</style>
